import {AppUrls} from 'shared/config/model/urls';

import React from 'react';
import {useNavigate} from 'react-router-dom';
import {t} from '@lingui/core/macro';

import Button from 'shared/ui/Button/Button/Button';
import Arrow from 'shared/ui/icons/Arrow';
import NoPayments from 'shared/ui/icons/NoPayments';
import {isTranslate} from 'shared/lib/lang';

import styles from './PaymentsPlug.module.scss';

const PaymentsPlug: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                {
                    !isTranslate() && <NoPayments />
                }
                <div className={styles.blockTitle}>
                    <span className={styles.title}>
                        {t`История платежей пуста`}
                    </span>
                    <span className={styles.text}>
                        <p>{t`После оплаты здесь появится история платежей`}.</p>
                        <p>{t`Платные тарифы открывают расширенные проверки мониторинга`}.</p>
                    </span>
                </div>
                <div className={styles.blockButton}>
                    <Button
                        onClick={() => navigate(AppUrls.TARIFFS)}
                        className={styles.button}
                    >
                        {t`Выбрать тариф`}
                    </Button>
                    <span className={styles.text}>
                        {t`Нажмите, чтобы выбрать тариф`}
                    </span>
                    <Arrow width={62} height={48}/>
                </div>
            </div>
        </div>
    );
};

export default PaymentsPlug;
